import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNotificationSound } from '../hooks/useNotificationSound';
import { supabase } from '../config/supabase';

export const MessageNotifications = () => {
  const { user } = useAuth();
  const { playNotification } = useNotificationSound();

  useEffect(() => {
    if (!user) return;

    const channel = supabase
      .channel('global_messages')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: `receiver_id=eq.${user?.id}`
        },
        (payload: any) => {
          if (payload.new && payload.new.sender_id !== user?.id) {
            playNotification();
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user, playNotification]);

  // Este componente no renderiza nada visualmente
  return null;
};
